const NextIcon: React.FC = () => {
    return (
        <svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.19331 19.5128L1.19331 1.4872L14.8952 10.5L1.19331 19.5128ZM9.02073e-08 19.9708C1.98721e-08 20.7733 0.816317 21.2661 1.45245 20.8476L15.8507 11.3768C16.4599 10.9761 16.4599 10.0239 15.8507 9.62321L1.45245 0.152371C0.816318 -0.266062 1.82081e-06 0.226717 1.75047e-06 1.02916L9.02073e-08 19.9708Z"
                fill="white"
            />
        </svg>
    )
}

NextIcon.displayName = 'NextIcon'

export default NextIcon
